import { observer } from 'mobx-react';
import { HeaderReview } from './header-review';
import { IStepControl, Step } from '../../../domains/wizard';
import { AddressReview } from './address-review';
import { ContactsReview } from './contacts-review';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../store';

interface IProps {
  stepControl: IStepControl;
}

export const ShippingStepReview = observer((props: IProps) => {
  const { t } = useTranslation('', { keyPrefix: 'REVIEW_AND_SIGN_UP' });
  const { t: tRestrictions } = useTranslation('', { keyPrefix: 'SHIPPING_INFORMATION.TIME_RESTRICTIONS' });
  const { shippingInformationStore: store, tenantStore } = useStore();
  const { displayTimeRestriction } = tenantStore.config;

  return (
    <div className="container-grey m-bottom-30 avoid-break">
      <HeaderReview stepControl={props.stepControl} step={Step.Shipping} />

      <span className="header-text-grey">{t('EQUIPMENT_WILL_BE_SHIPPED')}</span>
      <AddressReview addressType={'shipping'} />
      {displayTimeRestriction && store.information.timeRestriction.value && (
        <>
          <hr />
          <h4>{tRestrictions('TITLE')}</h4>
          <div className="container-readonly no-label">
            <span>{store.information.timeRestriction.value}</span>
          </div>
        </>
      )}
      <hr />
      <ContactsReview contactsType={'shipping'} />
    </div>
  );
});
